import Search from '@assets/icons/search.svg'
import { Icon } from './Icon'

export const SearchIcon = Icon(Search)
